// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.
import { FieldsFactory } from "../Factory/FieldsFactory.js"
import { Message } from "./Message.ts"
import { PFixMessage } from "./PFixMessage.js"
export let LogoutMessage = function (fieldSet)
{
    this.Code = Message.CODE_PFIX_LOGOUT_MESSAGE;
    PFixMessage.call(this, fieldSet);
}
LogoutMessage.prototype = Object.create(PFixMessage.prototype);

LogoutMessage.prototype.getText = function ()
{
    return this.getFieldValue(FieldsFactory.FIELD_TEXT);
}
LogoutMessage.prototype.setText = function (text)
{
    this.setFieldValue(FieldsFactory.FIELD_TEXT, text);
}

LogoutMessage.prototype.getSessionId = function ()
{
    return this.getFieldValue(FieldsFactory.FIELD_SESSIONID);
}
LogoutMessage.prototype.setSessionId = function (sessionId)
{
    this.setFieldValue(FieldsFactory.FIELD_SESSIONID, sessionId);
}

/// <summary>
/// для брокера, выбивающего трейдера
/// </summary>
LogoutMessage.prototype.setUserId = function (userId)
{
    this.setFieldValue(FieldsFactory.FIELD_USER_ID, userId);
}

LogoutMessage.prototype.getErrorCode = function ()
{
    return this.getFieldValue(FieldsFactory.FIELD_ERROR_CODE);
}

LogoutMessage.prototype.getLogoutType = function ()
{
    return this.getFieldValue(FieldsFactory.FIELD_TYPE);

}